/* eslint-disable max-len */
// GENERATED BY process-svg DO NOT EDIT
import React from 'react'
import { Icon, Props } from './Icon'

export const IconArrow = (props: Props) => (
  <Icon {...props}>
    <path className="path1" d="M7 10l5 5 5-5z" />
  </Icon>
)

// for use with mapbox addables.
export const IconArrowString =
  `<svg viewbox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path className="path1" d="M7 10l5 5 5-5z" />
  </svg>`

IconArrow.displayName = 'IconArrow'
